export type ChoiceItem = {
  _id: string;
  selectionId: number;
  value: string;
  description: string;
  isDisabled: boolean;
};

type CommonOptionProps = {
  selections: ChoiceItem[];
  selectionIds: number[];
};

export const getSelectedChoice = ({selections, selectionIds}: CommonOptionProps): ChoiceItem | undefined => {
  return selections.find((choice) => selectionIds.includes(choice.selectionId));
};

export const hasEmptySelections = ({selections}: CommonOptionProps): boolean => {
  return selections.length === 0;
};

export const getChoiceById = (selections: ChoiceItem[], _id: string): ChoiceItem | undefined => {
  return selections?.find((c) => c._id === _id);
};

export const getSelectedIndex = ({selections, selectionIds}: CommonOptionProps): number | undefined => {
  const index = selections.findIndex((choice) => selectionIds.includes(choice.selectionId));
  return index > -1 ? index : undefined;
};
